export const SUPPORTS_ARRAY_PROTOTYPE_VALUES = "values" in Array.prototype;
